import { useCallback } from 'react';
import { useIframeMessageContext } from '../../IframeMessageContext';
import { registerIframeMessageHook } from './IframeRegistration';
const MESSAGE_TYPE = 'new-route';
export function useSendNewRoute() {
    const { postMessage } = useIframeMessageContext();
    const sendNewRoute = useCallback((component) => {
        postMessage(MESSAGE_TYPE, component);
    }, [postMessage]);
    return { sendNewRoute };
}
const handleMessage = (context, message) => {
    // const { setNewRouteComponent } = context;
    // if (message.body) {
    //   const component = message.body;
    //   // console.log('received new component', component);
    //   setNewRouteComponent(component);
    //   // TODO: remove this once backend is implemented
    //   siteComponents.push(component);
    // }
};
registerIframeMessageHook(MESSAGE_TYPE, useSendNewRoute, handleMessage);
//# sourceMappingURL=useSendNewRoute.js.map